//Chave do sessionStorage com a mensagem apresentada na página de manutenção
export const CHAVE_MENSAGEM_MANUTENCAO = "mensagemManutencao";

//Evento disparado quando o bloqueio de manutenção é ligado ou desligado (para a tarja de aviso)
const EVENTO_MANUTENCAO = "siig-manutencao";

let manutencaoAtiva = false;

/*
 * Informa se o bloqueio de manutenção está ligado (conforme o cabeçalho da resposta do servidor)
 * e avisa a tarja quando o valor mudar
 */
export function fn_setManutencaoAtiva(ativa) {
  if (ativa != manutencaoAtiva) {
    manutencaoAtiva = ativa;
    window.dispatchEvent(new Event(EVENTO_MANUTENCAO));
  }
}

//Retorna se o bloqueio de manutenção está ligado
export function fn_isManutencaoAtiva() {
  return manutencaoAtiva;
}

//Executa a função sempre que o bloqueio de manutenção for ligado ou desligado. Retorna a função para remover
export function fn_onAlteracaoManutencao(fnAlteracao) {
  window.addEventListener(EVENTO_MANUTENCAO, fnAlteracao);
  return () => window.removeEventListener(EVENTO_MANUTENCAO, fnAlteracao);
}
